/* eslint-disable @typescript-eslint/no-explicit-any */
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['mousemove', 'mouseover', 'mouseenter', 'keydown', 'keyup', 'keypress'];
